import { BLUE } from '../constants/colors';

export default function TabBar({tabs,active,onChange}){
  return(
    <div style={{overflowX:"auto",WebkitOverflowScrolling:"touch",marginBottom:24,marginLeft:-4,marginRight:-4,paddingLeft:4,paddingRight:4}}>
      <div style={{display:"flex",gap:3,background:"#F1F5F9",borderRadius:12,padding:4,minWidth:"max-content"}}>
        {tabs.map(t=>(
          <button key={t.id} onClick={()=>onChange(t.id)}
            style={{flex:"0 0 auto",padding:"10px 14px",border:"none",borderRadius:9,cursor:"pointer",fontFamily:"sans-serif",fontSize:12,fontWeight:active===t.id?700:500,background:active===t.id?"#fff":"transparent",color:active===t.id?BLUE:"#64748b",boxShadow:active===t.id?"0 2px 10px rgba(0,0,0,0.09)":"none",transition:"all 0.2s",whiteSpace:"nowrap"}}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>
    </div>
  );
}
